import { render, staticRenderFns } from "./showResultScan.vue?vue&type=template&id=24de016b&scoped=true&"
import script from "./showResultScan.vue?vue&type=script&lang=js&"
export * from "./showResultScan.vue?vue&type=script&lang=js&"
import style0 from "./showResultScan.vue?vue&type=style&index=0&id=24de016b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Users/jason/development/social-marketing-recovered/client/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24de016b",
  null
  
)

export default component.exports